import React, { useState, useEffect } from 'react';
import { Card } from 'antd-mobile';

import { UrlSearch } from "../../../utils/utils";

import * as Api from "../../../api/usms";
import { TimeFormatType, TextCategory, AuditingStatus, UsmsType, UsmsStatus, UsmsStatusStyle, SignatureType, SignaturePurpose } from '../utils/const';
import { Loading, Descriptions } from '../components';
import CompanyInfo from '../components/CompanyInfo';
import SignatureAudit from './Audit';

import moment from 'moment';
import '../index.css';

function SignatureDetail(props) {

    const [signatureId, setSignatureId] = useState("");
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        initData()
    }, [])

    const initData = () => {
        const id = UrlSearch("id");
        setSignatureId(id);
        if (id) {
            getInfo(id);
        }
    }

    const getInfo = (signatureId) => {
        const data = {
            SignatureCategory: TextCategory,
            SignatureID: signatureId,
        }
        setLoading(true);
        Api.GetUSMSSignatureDetail(data).then(res => {
            setInfo(res);
            setLoading(false);
        }).catch(e => {
            setLoading(false);
            setErrorMessage(e.message || "获取数据失败")
        });
    }

    const infoOptions = (info) => [
        { label: '签名ID', value: info.SignatureId },
        { label: '短信类型', value: UsmsType[info.SignatureCategory] },
        { label: '签名类型', value: SignatureType[info.SignatureType] },
        { label: '签名用途', value: SignaturePurpose[info.SignaturePurpose] },
        { label: '国家简码', value: info.BrevityCode },
        { label: '签名内容', value: info.Signature },
        { label: '当前状态', value: <span className={UsmsStatusStyle[info.Status]}>{UsmsStatus[info.Status]}</span> },
        { label: '申请时间', value: moment(info.CreateTime * 1000).format(TimeFormatType.time_xg) },
        { label: '备注', value: info.Remark },
        { label: '自用审核材料', value: <a className="a-blue" href={info.Document}>查看</a> },
        { label: '签名授权协议书', value: <a className="a-blue" href={info.ProxyDoc}>查看</a> },
    ]
    return (
        <div className="container">
            <h3 className='mb-10'>短信签名：{signatureId}</h3>
            <Loading loading={loading} error={errorMessage} >
                <div>
                    <Card>
                        <Card.Body>
                            <CompanyInfo OrganizationId={info.OrganizationId} needRisk={true}/>
                        </Card.Body>
                    </Card>
                    <Card style={{ marginTop: '10px' }}>
                        <Card.Header title="签名信息" />
                        <Card.Body>
                            <Descriptions options={infoOptions(info)} />
                        </Card.Body>
                    </Card>
                    {AuditingStatus.includes(info.Status) ?
                        <div style={{ marginTop: '20px' }}>
                            <h3 style={{ marginBottom: '10px' }}>签名审核：</h3>
                            <SignatureAudit info={info} fetchBack={() => getInfo(signatureId)} />
                        </div> : null}
                </div>
            </Loading>
        </div>
    )
}

export default SignatureDetail